import packageJson from 'package.json';

export const environment = {
  production: true,
  name: 'test',
  appVersion: packageJson.version,
  apiDomain: 'identibase-api-test.azurewebsites.net',
  apiUrl: 'https://identibase-api-test.azurewebsites.net',
  domain: 'identibase-ui-test.azurewebsites.net',
  canonicalUrl: 'https://identibase-ui-test.azurewebsites.net',
  adminLoginUrl: 'https://identibase-admin-test.azurewebsites.net/Account/Account/Login',
  stripeKey: 'pk_test_48tn4LcO9gfF9M8nWltvlVWM005D9ppb6f',
  googleMapsApiKey: 'AIzaSyB1V1r4QFNAAWzJXNGHew65jgKPbUwxPfs',
  googleTagManagerId: 'GTM-K5TNGRH',
  segmentKey: '',
  stripePlans: {
    identibasePlus: 'price_1Qs39DGrKoMpYaks8dVXSnbh',
    identibasePlusCod: 'price_1Qs39YGrKoMpYaksFrZqdbx5',
    identiAlertMonthly: 'price_1Qs36uGrKoMpYaksEzyCv2Oz',
    identiAlertAnnual: 'price_1Qs32AGrKoMpYakseOPwNxxX',
    identiAlertFind: 'price_1Qs36GGrKoMpYaksU8Lhgh01',
    identiAlertFindCat: 'price_1Qs361GrKoMpYaksS66MvakP',
    identiAlertTok: 'price_1Qs338GrKoMpYaksT4MQm4u4',
    pitPatGpsTracker: 'price_1Qs3B4GrKoMpYaksIIZhZ2Zh',
    pitPatGpsTrackerBasic: 'price_1Ng76nGrKoMpYaksyokbsUSb',
    identiAlertTokBreeder: 'price_1Qs33kGrKoMpYaksn5CLDdUP',
  },
};
